module.exports = __webpack_public_path__ + "img/地图3_2_c.fca38423.png";